import { bbox } from "@turf/turf";
import { Feature } from "geojson";
import { pipe } from "fp-ts/function";
import { BBox } from "lib/at-data/BBox";

export const getFeatureBBox = <S, P>(f: Feature<S, P>) =>
  pipe(f, bbox, (_) => _ as BBox);
